import { useTranslation } from "react-i18next";

import React from 'react';
import { IStatus } from './Status.types';
import './style.scss';

const Status: React.FC<IStatus> = ({ status }: IStatus) => {
    const { t } = useTranslation();

    let statusTitle, statusClass;
    switch (status) {
        case "approved":
        case "deposit.portfolio_processed":
        case "withdrawal.portfolio_processed":
        case "change_investment.portfolio_processed":
        case "processed":
            statusTitle = t("approved");
            statusClass = "green";
            break;
        case "rejected":
            statusTitle = t("rejected");
            statusClass = "red";
            break;
        default:
            statusTitle = t("pending");
            statusClass = "blue";
    }

    return <span className={`status ${statusClass}`}>{statusTitle}</span>;
}

export { Status };
